export default "__VITE_ASSET__3BKICKoh__"